<template>
    <div :class="{'service_area':true,'odd':odd}" v-if="odd">
        <div v-for="(item,i) in arr" :key="i" :class="{'service_item':true,'service_first': i == 0}"
            @click="gotoDetail(item.game_id)">
            <div v-if="i==0">
                <div class="pic">
                    <img :src="item.game_banner" alt="" v-if="type == 2">
                    <img :src="item.newest_banner" alt="" v-else>
                    <div :class="{'service_status':true,'onstatus':item.serviceFlag,'offstatus':!item.serviceFlag}">
                        {{ item.serviceFlag?'已开服':'测试中' }}</div>
                </div>
                <div class="service_intr">
                    <div class="line_one">
                        <div class="game_name">{{item.game_name}}</div>
                        <div class="tags" v-if="item.tag&&item.tag.length > 0">
                            <div class="tag" v-for="(it,index) in item.tag.slice(0,3)" :key="index">{{it.tag_name}}
                            </div>
                        </div>
                    </div>
                    <div class="line_two" v-if="item.open_service_time">
                        <!-- {{item.open_service_time.slice(11,16)}}开服&nbsp; -->
                        {{item.reward}}
                    </div>
                </div>
            </div>
            <div class="service" v-else>
                <div class="pic">
                    <img :src="item.game_banner" alt="" v-if="type == 2">
                    <img :src="item.newest_banner" alt="" v-else>
                    <div :class="{'service_status':true,'onstatus':item.serviceFlag,'offstatus':!item.serviceFlag}">
                        {{ item.serviceFlag?'已开服':'测试中' }}</div>
                    <div class="line_two" v-if="item.open_service_time">
                        <!-- {{item.open_service_time.slice(11,16)}}开服&nbsp; -->
                        {{item.reward}}
                    </div>
                </div>
                <div class="line_one">
                    <div class="game_name">{{item.game_name}}</div>
                    <div class="tags" v-if="item.tag&&item.tag.length > 0">
                        <div class="tag" v-for="(it,index) in item.tag.slice(0,2)" :key="index">{{it.tag_name}}</div>
                    </div>
                    <div class="tags" v-else></div>
                </div>
            </div>
        </div>
    </div>
    <div :class="{'service_area':true,'even':even}" v-else-if="even">
        <div v-for="(item,i) in arr" :key="i" :class="{'service_item':true}" @click="gotoDetail(item.game_id)">
            <div class="service">
                <div class="pic">
                    <img :src="item.game_banner" alt="" v-if="type == 2">
                    <img :src="item.newest_banner" alt="" v-else>
                    <div :class="{'service_status':true,'onstatus':item.serviceFlag,'offstatus':!item.serviceFlag}">
                        {{ item.serviceFlag?'已开服':'测试中' }}</div>
                    <div class="line_two" v-if="item.open_service_time">
                        <!-- {{item.open_service_time.slice(11,16)}}开服&nbsp; -->
                        {{item.reward}}
                    </div>
                </div>
                <div class="line_one">
                    <div class="game_name">{{item.game_name_main}}</div>
                    <div class="tags" v-if="item.tag&&item.tag.length > 0">
                        <div class="tag" v-for="(it,index) in item.tag.slice(0,3)" :key="index">{{it.tag_name}}</div>
                    </div>
                    <div class="tags" v-else></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'service-item',
        props: ['arr', 'odd', 'even', 'type'], //odd 奇数  even 偶数
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            gotoDetail(id) {
                //this.$parent.openGame(id)
            }
        },
    }
</script>

<style lang="less" scoped>
    .service_area {
        display: flex;
        flex-wrap: wrap;

        .service_item {
            width: calc(35/71*100%);
            margin-bottom: .5rem;
            border-radius: .7rem;
            overflow: hidden;
            cursor: pointer;

            &.service_first {
                width: 100%;

                .pic {
                    width: 100%;
                    padding-bottom: calc(380/708*100%);
                    position: relative;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                    }

                    .service_status {
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 2;
                        padding: .1rem .6rem;
                        font-size: .6rem;
                        color: #fff;
                        border-bottom-left-radius: .2rem;

                        &.onstatus {
                            background-color: #999;
                        }

                        &.offstatus {
                            background-color: #670000;
                        }
                    }
                }

                .service_intr {
                    background-color: #fff;
                    padding: .4rem .5rem;

                    .line_one {
                        display: flex;
                        align-items: center;
                        margin-bottom: .25rem;

                        .game_name {
                            color: #000;
                            font-size: .75rem;
                            font-weight: 700;
                            margin-right: .8rem;
                        }

                        .tags {
                            display: flex;
                            align-items: center;

                            .tag {
                                font-size: .6rem;
                                background-color: #fdf9f1;
                                color: #b87e1c;
                                padding: .05rem .2rem;
                                border-radius: .2rem;
                                margin-right: .35rem;

                                &:nth-child(1) {
                                    background-color: rgba(48, 40, 46, 0.34);
                                    color: #fff;
                                }

                                &:nth-child(2) {
                                    background-color: rgba(154, 89, 89, 0.42);
                                    color: #fff;
                                }
                                &:nth-child(3) {
                                    background-color: rgba(196, 200, 159, 0.16);
                                    color: #C4C89F;
                                }
                            }
                        }
                    }

                    .line_two {
                        width: 100%;
                        color: #9e9e9e;
                        font-size: .6rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .service {
                .pic {
                    width: 100%;
                    padding-bottom: calc(184/348*100%);
                    position: relative;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                    }

                    .service_status {
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 2;
                        padding: .1rem .6rem;
                        font-size: .6rem;
                        color: #fff;
                        border-bottom-left-radius: .4rem;

                        &.onstatus {
                            background-color: #999;
                        }

                        &.offstatus {
                            background-color: #670000;
                        }
                    }

                    .line_two {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 1.2rem;
                        line-height: 1.2rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        z-index: 2;
                        color: #f7f5f4;
                        font-size: .6rem;
                        background-color: rgba(0, 0, 0, 0.6);
                        padding: 0 .3rem;
                    }
                }

                .line_one {
                    background-color: #fff;
                    padding: .2rem .5rem .7rem;

                    .game_name {
                        color: #000;
                        font-size: .75rem;
                        font-weight: 700;
                        margin-bottom: .3rem;
                    }

                    .tags {
                        display: flex;
                        align-items: center;
                        transform: translateX(-0.15rem);
                        height: 1rem;

                        .tag {
                            font-size: .6rem;
                            background-color: #fdf9f1;
                            color: #b87e1c;
                            padding: .05rem .2rem;
                            border-radius: .2rem;
                            margin-right: .35rem;

                            &:nth-child(1) {
                                background-color: rgba(196, 200, 159, 0.16);
                                color: #C4C89F;
                            }

                            &:nth-child(2) {
                                background-color: rgba(48, 40, 46, 0.34);
                                color: #fff;
                            }

                            &:nth-child(3) {
                                background-color: rgba(154, 89, 89, 0.42);
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        &.odd {
            .service_item:nth-child(2n) {
                margin-right: 1%;
            }
        }

        &.even {
            .service_item:nth-child(2n+1) {
                margin-right: 1%;
            }
        }
    }
</style>